// Cena 6 — Contatos (áudio ~18s)
// A agenda: contatos entram sozinhos quando o cliente chama, e o cadastro
// manual acontece pelo botão real "Adicionar contato" + modal fictício.
const MAIN = "[data-tour='main-content']";
const BTN_ADD = "[data-tour='btn-add-contact']";
const SAVE = "[data-demo='save']";
const CONTACT_J = "[data-demo='contact-J']";
const CONTACT_M = "[data-demo='contact-M']";
const CONTACT_C = "[data-demo='contact-C']";

export default async function contacts(ctx) {
	ctx.spotlight(MAIN);
	await ctx.wait(600);

	// "quem te chama entra aqui sozinho" — contatos surgem na lista
	ctx.mount("contactRow", MAIN, {
		name: "João Pereira",
		number: "+55 11 99999-1234",
		initial: "J",
		color: "#3B82F6",
		style: { position: "absolute", left: 24, top: 120, width: 400 },
	});
	await ctx.wait(450);
	ctx.mount("contactRow", MAIN, {
		name: "Maria Souza",
		number: "+55 11 98888-4321",
		initial: "M",
		color: "#8B5CF6",
		style: { position: "absolute", left: 24, top: 190, width: 400 },
	});
	await ctx.wait(400);

	// cursor passeia pelos contatos enquanto a narração apresenta a agenda
	await ctx.waitFor(CONTACT_J);
	await ctx.cursorTo(CONTACT_J, { duration: 850 });
	await ctx.wait(800);
	await ctx.waitFor(CONTACT_M);
	await ctx.cursorTo(CONTACT_M, { duration: 650 });
	await ctx.wait(800);

	// "cadastrar clientes manualmente" — botão REAL de adicionar contato
	await ctx.waitFor(BTN_ADD);
	await ctx.cursorTo(BTN_ADD, { duration: 900 });
	await ctx.wait(300);
	await ctx.click(BTN_ADD);
	await ctx.wait(400);

	// modal fictício (centraliza e desfoca o fundo sozinho) com digitação
	const modal = ctx.mount("formModal", MAIN, {
		title: "Novo contato",
		fields: [
			{ label: "Nome", value: "Carlos Mendes", done: false },
			{ label: "WhatsApp", value: "+55 11 97777-0000", done: false },
		],
	});
	await ctx.wait(3200);
	ctx.update(modal, {
		fields: [
			{ label: "Nome", value: "Carlos Mendes", done: true },
			{ label: "WhatsApp", value: "+55 11 97777-0000", done: true },
		],
	});

	// clique no SALVAR do próprio modal
	await ctx.waitFor(SAVE);
	await ctx.cursorTo(SAVE, { duration: 750 });
	await ctx.wait(250);
	await ctx.click(SAVE);
	ctx.update(modal, {
		saving: true,
		fields: [
			{ label: "Nome", value: "Carlos Mendes", done: true },
			{ label: "WhatsApp", value: "+55 11 97777-0000", done: true },
		],
	});
	await ctx.wait(900);
	ctx.unmount(modal);
	await ctx.wait(350);

	// contato novo entra na lista, com destaque
	ctx.mount("contactRow", MAIN, {
		name: "Carlos Mendes",
		number: "+55 11 97777-0000",
		initial: "C",
		color: "#10B981",
		highlight: true,
		style: { position: "absolute", left: 24, top: 260, width: 400 },
	});
	await ctx.waitFor(CONTACT_C);
	await ctx.cursorTo(CONTACT_C, { duration: 700 });
	await ctx.wait(400);

	// toast grande fixo embaixo no centro (sem style de posição)
	const toast = ctx.mount("toast", MAIN, {
		icon: "✅",
		text: "Contato criado!",
	});
	await ctx.wait(2300);
	ctx.unmount(toast);

	// estado final: os três contatos ficam na tela
	ctx.spotlight(null);
	await ctx.wait(400);
}
